import { render, staticRenderFns } from "./YoutubeCover.vue?vue&type=template&id=38c758e4&scoped=true&"
import script from "./YoutubeCover.vue?vue&type=script&lang=js&"
export * from "./YoutubeCover.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeCover.vue?vue&type=style&index=0&id=38c758e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c758e4",
  null
  
)

/* custom blocks */
import block0 from "./YoutubeCover.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports